export default {"src":"/_next/static/media/brand-service.0cff3468.svg","height":420,"width":550};